/** Тексты интерфейса BotPhoto.VCHIPS; меняют только локальный черновик. */
export const videoPromptPresets = [
  ['Город ночью', 'Камера медленно летит над ночным городом, огни и мокрый асфальт'],
  ['Океан', 'Волны разбиваются о скалы на закате, брызги в замедлении'],
  ['Кафе', 'Уютное кафе, пар над чашкой кофе, за окном дождь'],
  ['Космос', 'Полёт сквозь туманность к яркой звезде'],
  ['Лес', 'Утренний лес, туман и лучи солнца сквозь листву'],
] as const;
